module.exports = __webpack_public_path__ + "a9b755a34adcd61b08eb8ecca565a206.woff2";